var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-tabs',[_c('v-tab',[_vm._v("AdHoc")]),_c('v-tab-item',[_c('VwApplicationReportGrid')],1),_c('v-tab',[_vm._v("Canned")]),_c('v-tab-item',[_c('CannedReportsGrid')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }